var md = new MobileDetect(window.navigator.userAgent);

var site = {
	rate : 500,
    timeout : 5000
};

Object.size = function(obj) {
	var size = 0, key;
	for (key in obj) {
		if (obj.hasOwnProperty(key)){
			size++;
		}
	}
	return size;
};

(function($) {


    $('.header-menu--toggle').click(function(){
        var $navbar = $('.modal-navbar');
        if( $('.modal-navbar').hasClass('active') ){
            $('.modal-navbar').removeClass('active');
            $('body').removeClass('header-active');
        }else{

            $navbar.addClass('active');
            $('body').addClass('header-active');
            $navbar.one('webkitTransitionEnd otransitionend oTransitionEnd msTransitionEnd transitionend',function(e){
                $("html, body").delay(500).animate({ scrollTop: 0 }, 1);
            });
        }
    });

    var $steps = $('.steps');

    $steps.cycle({
        timeout: 0,
        speed: 500,
        pager: '.steps-header--pager',
        swipe : true,
        slides : "> .step-slide",
        fx : 'fade',
        autoHeight : 'calc',
        swipeFx :  'scrollHorz',
        prev: '.steps-prev',
        next: '.steps-next',
        pagerTemplate: ""
    });

    $steps.on( 'cycle-before', function(event, optionHash, outgoingSlideEl, incomingSlideEl, forwardFlag){
        console.log( $(incomingSlideEl).index() );
        var i = $(incomingSlideEl).index();
        $('.steps-header--nums').fadeOut(250,function(){
            $('.steps-header--nums').html("0"+i);
            $('.steps-header--nums').fadeIn(250);
        });
    });

    if( $('#grid').length && !md.phone() ){

        var container = document.querySelector('#grid');

        pckry = new Packery( container, {
            gutter: ".gutter-sizer",
            itemSelector: ".gallery-item",
            columnWidth: ".grid-sizer"
        });
        pckry.layout();

    }

    /*

    Scrollmagic

    *******************************************************/

    var controller = new ScrollMagic.Controller();

    if( $('.module-parallax').length ){

        $('.module-parallax').each(function(){

            var $photo = $(this).find('.parallax-photo');

            var slideParallaxScene = new ScrollMagic.Scene({
                triggerElement: this,
                triggerHook: 1,
                duration: '150%'
            })
            .setTween( TweenMax.from($photo, 1, {y:'-50%', ease:Power0.easeNone}, 0) )
            .addTo(controller);

        });

    }

    if( $('.sh').length ){

        $('.sh.vert').each(function(){

            var $shape = $(this);

            var shapeParallaxScene = new ScrollMagic.Scene({
                triggerElement: this,
                triggerHook: 1,
                duration: '150%'
            })
            .setTween( TweenMax.fromTo($shape, 1, {y:'-25%', ease:Power0.easeNone}, {y:'+25%', ease:Power0.easeNone}) )
            .addTo(controller);

        });

    }

    $.fancybox.defaults.animationEffect = "fade";

})(jQuery);